import { Injectable } from '@angular/core';
import { tokenSaleMarketAbi } from './abi/token-sale-market-abi';

@Injectable({
  providedIn: 'root'
})
export class TokenSaleMarketInstanceService {

  constructor() { }

  instantiate( web3, address ) {
    return new web3.eth.Contract( tokenSaleMarketAbi, address );
  }
}
